import { BodyCell } from '../ui/components';
import classnames from 'classnames';
import { Tooltip } from '../../../components/ui/tooltip';
import { Box } from '@mui/system';
import { IDisplayLabelCellProps } from './display-label-cell.interfaces';

export const DisplayLabelCell = ({ rowData }: IDisplayLabelCellProps) => {
  const label = rowData.displayName;

  return (
    <BodyCell className={classnames({ dim: rowData.hidden })}>
      <Tooltip placement='top' arrow title={label}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Box>
      </Tooltip>
    </BodyCell>
  );
};
